import { AppContext, AppSettings } from './hooks/useAppContext';
import { RouterProvider } from 'react-router-dom';
import useCookies from './hooks/useCookies';
import { Toaster } from 'react-hot-toast';
import { RequireAuth } from './pages/login/RequireAuth';
import { PrimeReactProvider } from 'primereact/api';
import { Router } from './routes/routes';

const App = () => {
  const { value, update } = useCookies<string>('lang', 'ru');
  const context = { Lang: value, SetLang: update } as AppSettings;

  return (
    <div>
      <AppContext.Provider value={context}>
        <PrimeReactProvider value={{ appendTo: document.body }}>
          <RequireAuth>
            <RouterProvider router={Router}></RouterProvider>
          </RequireAuth>
          <Toaster position="top-center" />
        </PrimeReactProvider>
      </AppContext.Provider>
    </div>
  );
};

export default App;
